import SystemStats from './SystemStats';
import ActiveSessions from './ActiveSessions';
import NetworkPorts from './NetworkPorts';


function Home() {

    return (
        <div
            className="flex flex-col gap-4 px-4"
        >

            <SystemStats/>

            <ActiveSessions/>

            <NetworkPorts/>

        </div>
    );
}

export default Home;
